import React from 'react'
import Detelis from './Detelis'
import PageHeader from './PageHeader'

const ShopDetelis = () => {
  return (
    <>
      <PageHeader />
      <Detelis />

    </>
  )
}

export default ShopDetelis